const raceDisplayOptions = [
  { value: '0', label: 'Select'},
  { value: '1', label: 'Asian' },
  { value: '2', label: 'Caucasian'},
  { value: '3', label: 'African American'},
  { value: '4', label: 'Unknown'},
]

export default raceDisplayOptions
